// this assumes n is a number.
function iseven(n) {
	if( n % 2 == 0 ){
		return true;
	}else{
		return false;
	}
};

module.exports = iseven;


/** WEBPACK FOOTER **
 ** ./src/js/helpers/iseven.js
 **/